import {
  AirplaneTilt, CalendarCheck, ForkKnife, Coffee,
  Wine, Package, Ticket, Gift,
} from "@phosphor-icons/react";

export const PHONE = "(902) 999-9066";
export const PHONE_RAW = "9029999066";
export const EMAIL = "BOOKINGS@DSCABS.CA";
export const COMPANY = "DS CABS & Delivery inc.";
export const COMPANY_UPPER = "DS CABS & DELIVERY INC.";
export const AKA = "Windsor Taxi";
export const RATING = { score: "5.0", label: "Rated 5.0 on Google", sub: "Highly recommended by the community" };
export const QUICK_SERVICES = [
  "DS Executive Ride",
  "Taxi Ride (In-Town)",
  "Out of Town Trip",
  "Halifax Airport Transfer",
  "Food / Drinks Delivery",
  "Parcel & Package Delivery",
  "Special Arrangement",
];

export const WHATSAPP = "19029999066";
export const OFFICE = "402 Highland Avenue, Windsor, NS";
export const SOCIALS = {
  facebook: "https://facebook.com/DSCabsDelivery9029999066",
  instagram: "https://instagram.com/ds_cabs_",
};

export const FACEBOOK_PAGE = "https://www.facebook.com/DSCabsDelivery9029999066";
export const GOOGLE_REVIEW = "https://www.google.com/maps/search/?api=1&query=DS%20CABS%20%26%20Delivery%20Windsor%20NS";

export const SERVICES = [
  {
    key: "airport",
    title: "Airport Transfers",
    tagline: "On time, every time",
    desc: "Reliable runs to Halifax Stanfield — early flights, late landings, we're there.",
    Icon: AirplaneTilt,
    accent: "#0055FF",
    span: "md:col-span-8",
    img: "https://images.unsplash.com/photo-1569154941061-e231b4725ef1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "appointments",
    title: "Appointment Rides",
    tagline: "Safe & reliable",
    desc: "Never miss a medical or personal appointment. Door-to-door care.",
    Icon: CalendarCheck,
    accent: "#FF3B30",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1616196334411-1d8d09708ca6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    key: "fooddrinks",
    title: "Food & Drinks Delivery",
    tagline: "Meals, snacks & drinks",
    desc: "Breakfast, lunch, supper, snacks and drinks — hot, fresh and fast to your door.",
    Icon: ForkKnife,
    accent: "#FF3B30",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1600728619239-d2a73f7aa541?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    key: "parcel",
    title: "Parcel & Package",
    tagline: "Fast, safe, secure",
    desc: "Documents, packages and parcels moved across town — handled with care.",
    Icon: Package,
    accent: "#0055FF",
    span: "md:col-span-4",
    img: "https://images.unsplash.com/photo-1566576721346-d4a3b4eaeb55?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "gift",
    title: "Send a Gift",
    tagline: "Gifts, flowers & cake",
    desc: "Surprise someone with gifts, flowers, cakes & birthday treats — delivered to their door, even at midnight.",
    Icon: Gift,
    accent: "#FF3B30",
    span: "md:col-span-4",
    route: "/special-arrangements",
    img: "https://images.unsplash.com/photo-1608825154649-2e9bb4cd4211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "events",
    title: "Games & Events",
    tagline: "We'll get you there",
    desc: "Hockey, concerts, gatherings — rides to and from every event.",
    Icon: Ticket,
    accent: "#FF3B30",
    span: "md:col-span-12",
    img: "https://images.unsplash.com/photo-1705593973313-75de7bf95b56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const SERVICE_OPTIONS = [
  "DS Executive Ride",
  ...SERVICES.map((s) => s.title),
  "Special Arrangement (Gifts, Flowers, Cake)",
];

export const EXECUTIVE = {
  vehicle: "White Executive Van",
  exterior: "https://images.unsplash.com/photo-1623371857133-6d5552bbdc13?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  interior: "https://images.unsplash.com/photo-1623372080637-1fcf59774fe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  features: [
    "Spacious white executive van",
    "Extra legroom & premium comfort",
    "Always on time — guaranteed",
    "Professional, friendly local driver",
    "Clean & sanitized every ride",
    "Seats up to 6 guests + luggage",
  ],
  perks: [
    "Meet & greet service",
    "Complimentary bottled water",
    "USB fast-charging",
    "Child seat on request",
    "Card · Tap · E-Transfer",
    "Discreet, quiet ride",
  ],
};

export const AREAS = [
  "Windsor", "Falmouth", "Hantsport", "Wolfville", "Mount Uniacke",
  "Walton", "Martock", "Newport", "Vaughan", "Avondale", "Avonport",
  "Brooklyn", "Cheverie", "New Ross", "Ellershouse", "Saint Croix",
  "Scotch Village", "Upper Falmouth", "Rawdon Gold Mines", "Three Mile Plains",
  "Halifax Airport",
];

export const SPECIAL_SLOGAN = "Craving happiness? We knock on your door.";

export const SPECIAL_ITEMS = [
  { title: "Gifts", desc: "Surprise someone with the perfect gift, hand-delivered." },
  { title: "Birthday Cakes", desc: "Cake at the door right on midnight — make the wish count." },
  { title: "Fresh Flowers", desc: "Bouquets picked up and delivered while they're still fresh." },
  { title: "Food & Treats", desc: "Late-night cravings sorted — snacks, meals and sweets." },
];

export const MANIFESTO = [
  { n: "01", title: "One call. One text.", body: "You reach out once. We handle the rest — the route, the timing, the details. No apps to fight, no waiting on hold." },
  { n: "02", title: "Rides and deliveries.", body: "People, parcels, groceries, dinner, drinks. If it needs to move across Windsor, we move it — safely and on time." },
  { n: "03", title: "Around the clock.", body: "5 AM airport run or a late-night lift home, we're always ready. 24/7 means 24/7 in our book." },
  { n: "04", title: "Our community.", body: "We're local. Every ride supports the neighbours, businesses and streets we call home. Your comfort, our priority." },
];

export const TESTIMONIALS = [
  { name: "Dr Paramita Saha", role: "Local Guide · 31 reviews", quote: "I had a great experience with DS Cab in Nova Scotia! The owner was always available to take calls, very polite, and quick to help whenever needed. Punctual, professional, and very affordable rates. Highly recommend them!", rating: 5, source: "Google" },
  { name: "William Fraser", role: "Windsor", quote: "Excellent service, speedy times, and always gets me what I want exactly. I wish I could give 6 stars.", rating: 5, source: "Google" },
  { name: "Bambi D.", role: "Windsor", quote: "Prompt, professional, and always helpful! My favorite cab and delivery service for sure.", rating: 5, source: "Google" },
  { name: "Cassy MacGillivary", role: "Windsor", quote: "Excellent service!!! Very friendly and accommodating.", rating: 5, source: "Google" },
  { name: "Alex", role: "Windsor", quote: "Best cab service in Windsor.", rating: 5, source: "Google" },
  { name: "Beaver Dewberry", role: "Windsor", quote: "Good experience, comfortable, and affordable.", rating: 5, source: "Google" },
  { name: "Joe MacDonald", role: "Windsor", quote: "The owner/driver took us to a few places in town. We had a tentative schedule and he was always there waiting to pick us up. He even let me run a tab and pay at the end of the night. Great guy!", rating: 5, source: "Google" },
  { name: "Ma. Cristylyn Mae Cagay", role: "Windsor", quote: "DS Cabs and Delivery in Nova Scotia is a trusted cab we really have. The driver was nice, friendly, approachable, respectful and helps you whenever you're in need. Excellent service!", rating: 5, source: "Google" },
  { name: "Joeron Dalisay", role: "Windsor", quote: "Fast and reliable service. Always on time and easy to reach when you need a ride. DS CABS is dependable and makes the trip smooth and stress free. Highly recommended.", rating: 5, source: "Google" },
  { name: "Sumit Bhanot", role: "Windsor", quote: "DS Cabs and Delivery provides excellent service. Always on time, professional drivers, and very reliable. I'd definitely recommend them to others!", rating: 5, source: "Google" },
  { name: "Vineet Thakur", role: "Windsor", quote: "A wonderful experience with the cab service. The driver arrived on time and stayed professional throughout. The vehicle was clean, well-maintained and comfortable.", rating: 5, source: "Google" },
  { name: "Kirandeep Kaur", role: "Windsor", quote: "Had a wonderful ride! The driver was very friendly, the car was clean, on time, and everything felt safe. Very reliable and smooth trip.", rating: 5, source: "Google" },
  { name: "Sachin Madotra", role: "Local Guide · Windsor", quote: "Best service in the town — very affordable and comfortable. 100%!", rating: 5, source: "Google" },
  { name: "M&A Bro", role: "Windsor", quote: "Reasonable person, got me safe from Windsor to Halifax. If you want a taxi just call him.", rating: 5, source: "Google" },
  { name: "Wayne Chretien", role: "Windsor", quote: "Awesome service, very clean car, very helpful and on time.", rating: 5, source: "Google" },
  { name: "Cassidy Erin", role: "Windsor", quote: "Incredible friendly person who goes above and beyond! I'm extremely glad this town has a company like this!", rating: 5, source: "Google" },
  { name: "Angelina Claes", role: "Windsor", quote: "Fantastic service! Clean cars and reasonable rates!", rating: 5, source: "Google" },
  { name: "Holden Griffiths", role: "Windsor", quote: "Was very friendly and pleasant. Recommend over any other taxis :)", rating: 5, source: "Google" },
  { name: "Logan Carr", role: "Windsor", quote: "Great guy — always responds quickly and comes at any time needed.", rating: 5, source: "Google" },
  { name: "Paul Walchhuetter", role: "Windsor", quote: "Really nice guy. Gave me free fries after some of them fell. 10/10.", rating: 5, source: "Google" },
  { name: "Hisham Jamal", role: "Local Guide · Windsor", quote: "Great service, nice people, and fast response. Thank you so much for your service!", rating: 5, source: "Google" },
  { name: "Abhishek Garg", role: "Windsor", quote: "DS Cabs and Delivery is super reliable and always on time. Great service!", rating: 5, source: "Google" },
  { name: "Dylan", role: "Windsor", quote: "Greatest taxi around.", rating: 5, source: "Google" },
  { name: "Rahul Dahiya", role: "Windsor", quote: "Best!", rating: 5, source: "Google" },
];
